import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import OtoSpinner from '../common/OtoSpinner';
import Shapes from '../../app/shapes/main';
var spinnerInstance = React.createElement(OtoSpinner, null);
var fullSizeStyle = { height: '100%', width: '100%' };
var DishImage = function (_a) {
    var dish = _a.dish, inIframe = _a.inIframe, isStatic = _a.isStatic;
    if (!inIframe) {
        return React.createElement(LazyLoad, { offset: 200, once: true, placeholder: spinnerInstance, style: fullSizeStyle },
            React.createElement("img", { className: isStatic ? 'dish__img-static' : 'dish__img', src: dish.image }));
    }
    return React.createElement(LazyLoadImage, { alt: dish.name, src: dish.image, width: "100%" });
};
DishImage.propTypes = {
    dish: Shapes.restaurantMenuItemWithCategoryShape.isRequired,
    inIframe: PropTypes.bool.isRequired,
    isStatic: PropTypes.bool.isRequired,
};
export default DishImage;
